// GENERATED by tools/single-file.py — the ladders below are loop regions inside one bounced
// file, not hand-written numbers. Re-render with:
//   npx vite-node tools/dump-banks.mts /tmp/rerender/banks.json
//   python3 tools/single-file.py /tmp/rerender/banks.json ferrari-458-4v /tmp/rerender/ferrari-458   (sources: see the docstring)
//   python3 tools/single-file.py encode ferrari-458-4v /tmp/rerender/ferrari-458 && python3 tools/apply-ladders.py ...
import type { EngineLoopSample } from '../CarProfile';
import { asSingleFile } from '../single-file';
import { ferrari458 } from '../ferrari-458';

const loop = (id: string, file: string, recordedRpm: number, loopStart: number, loopEnd: number): EngineLoopSample =>
  ({ id, file, recordedRpm, loopStart, loopEnd });

export const ferrari458Single = asSingleFile(ferrari458, {
  id: 'ferrari-458',
  slug: '570-hp-v8',
  name: '570 HP V8',
  baseGain: 1.000,
  adminOnly: false,  // LIVE 2026-09-02 — see the licence note in ../ferrari-458.ts

  on: [
  loop('on_877', 'single', 877, 0.000000, 11.982896),
  loop('on_1225', 'single', 1225, 11.982896, 25.474062),
  loop('on_1635', 'single', 1635, 25.474062, 40.467188),
  loop('on_2000', 'single', 2000, 40.467188, 42.466354),
  loop('on_2380', 'single', 2380, 42.466354, 44.461792),
  loop('on_2705', 'single', 2705, 44.461792, 46.457292),
  loop('on_3010', 'single', 3010, 46.457292, 48.456688),
  loop('on_3574', 'single', 3574, 48.456688, 50.452500),
  loop('on_3990', 'single', 3990, 50.452500, 52.451833),
  loop('on_4682', 'single', 4682, 52.451833, 54.451188),
  loop('on_5000', 'single', 5000, 54.451188, 56.450292),
  loop('on_5595', 'single', 5595, 56.450292, 58.447604),
  loop('on_6000', 'single', 6000, 58.447604, 60.446458),
  loop('on_6442', 'single', 6442, 60.446458, 62.446458),
  loop('on_7000', 'single', 7000, 62.446458, 64.445229),
  loop('on_7390', 'single', 7390, 64.445229, 66.444688),
  loop('on_7952', 'single', 7952, 66.444688, 68.444000),
  loop('on_8276', 'single', 8276, 68.444000, 70.443917),
  loop('on_9000', 'single', 9000, 70.443917, 72.443917),
  ],
  mid: [
  loop('mid_877', 'single', 877, 72.443917, 84.426812),
  loop('mid_1225', 'single', 1225, 84.426812, 97.918312),
  loop('mid_1635', 'single', 1635, 97.918312, 112.910479),
  loop('mid_2000', 'single', 2000, 112.910479, 114.908271),
  loop('mid_2380', 'single', 2380, 114.908271, 116.903667),
  loop('mid_2705', 'single', 2705, 116.903667, 118.901250),
  loop('mid_3010', 'single', 3010, 118.901250, 120.900937),
  loop('mid_3574', 'single', 3574, 120.900937, 122.900208),
  loop('mid_3990', 'single', 3990, 122.900208, 124.899187),
  loop('mid_4682', 'single', 4682, 124.899187, 126.897792),
  loop('mid_5000', 'single', 5000, 126.897792, 128.896583),
  loop('mid_5595', 'single', 5595, 128.896583, 130.894021),
  loop('mid_6000', 'single', 6000, 130.894021, 132.892729),
  loop('mid_6442', 'single', 6442, 132.892729, 134.891604),
  loop('mid_7000', 'single', 7000, 134.891604, 136.891458),
  loop('mid_7390', 'single', 7390, 136.891458, 138.891417),
  loop('mid_7952', 'single', 7952, 138.891417, 140.890667),
  loop('mid_8276', 'single', 8276, 140.890667, 142.890417),
  loop('mid_9000', 'single', 9000, 142.890417, 144.889833),
  ],
  off: [
  loop('off_877', 'single', 877, 144.889833, 156.872729),
  loop('off_1225', 'single', 1225, 156.872729, 170.365104),
  loop('off_1635', 'single', 1635, 170.365104, 185.357417),
  loop('off_2000', 'single', 2000, 185.357417, 187.355854),
  loop('off_2380', 'single', 2380, 187.355854, 189.350583),
  loop('off_2705', 'single', 2705, 189.350583, 191.346979),
  loop('off_3010', 'single', 3010, 191.346979, 193.346333),
  loop('off_3574', 'single', 3574, 193.346333, 195.346021),
  loop('off_3990', 'single', 3990, 195.346021, 197.345208),
  loop('off_4682', 'single', 4682, 197.345208, 199.344375),
  loop('off_5000', 'single', 5000, 199.344375, 201.343000),
  loop('off_5595', 'single', 5595, 201.343000, 203.340313),
  loop('off_6000', 'single', 6000, 203.340313, 205.338271),
  loop('off_6442', 'single', 6442, 205.338271, 207.335938),
  loop('off_7000', 'single', 7000, 207.335938, 209.334250),
  loop('off_7390', 'single', 7390, 209.334250, 211.334250),
  loop('off_7952', 'single', 7952, 211.334250, 213.333229),
  loop('off_8276', 'single', 8276, 213.333229, 215.332583),
  loop('off_9000', 'single', 9000, 215.332583, 217.330917),
  ],
});
